"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const getCampaignType_1 = require("../views/utils/getCampaignType");
const app_1 = require("./app"), appSelector = app_1;
const campaignConnection_1 = require("./campaignConnection"), campaignsSelector = campaignConnection_1;
const campaignExport_1 = require("./campaignExport");
const campaignReport_1 = require("./campaignReport"), campaignReportSelector = campaignReport_1;
const deviceLists_1 = require("./deviceLists"), deviceListsSelector = deviceLists_1;
const deviceSchema_1 = require("./deviceSchema"), deviceSchemaSelector = deviceSchema_1;
const editableCampaign_1 = require("./editableCampaign"), editableCampaignSelector = editableCampaign_1;
const editableUIState_1 = require("./editableUIState"), editableUIStateSelector = editableUIState_1;
const eventSchemas_1 = require("./eventSchemas"), eventSchemasSelector = eventSchemas_1;
const experiences_1 = require("./experiences"), experiencesSelector = experiences_1;
const experienceReport_1 = require("./experienceReport"), experienceReportSelector = experienceReport_1;
const reports_1 = require("./reports"), reportsSelector = reports_1;
const segments_1 = require("./segments"), segmentsSelector = segments_1;
const testDevices_1 = require("./testDevices"), testDevicesSelector = testDevices_1;
const user_1 = require("./user"), userSelector = user_1;
const tags_1 = require("./tags"), tagsSelector = tags_1;
exports.default = redux_1.combineReducers({
    app: app_1.default,
    campaignConnection: campaignConnection_1.default,
    campaignExport: campaignExport_1.default,
    campaignReport: campaignReport_1.default,
    deviceLists: deviceLists_1.default,
    deviceSchema: deviceSchema_1.default,
    editableCampaign: editableCampaign_1.default,
    editableUIState: editableUIState_1.default,
    eventSchemas: eventSchemas_1.default,
    experiences: experiences_1.default,
    experienceReport: experienceReport_1.default,
    reports: reports_1.default,
    segments: segments_1.default,
    testDevices: testDevices_1.default,
    user: user_1.default,
    tags: tags_1.default,
});
exports.getDeviceLists = (state) => deviceListsSelector.getDeviceLists(state.deviceLists);
exports.getShouldShowDeviceListOption = (state) => {
    const settings = exports.getSettings(state);
    const { keyPaths } = settings;
    const { __typename } = exports.getEditableCampaignTrigger(state);
    return (settings &&
        keyPaths &&
        keyPaths.length > 0 &&
        (__typename === 'CampaignScheduledTrigger' || __typename === 'CampaignAutomatedTrigger'));
};
exports.getShouldShowTicketingFeatures = (state) => {
    const settings = exports.getSettings(state);
    return settings.ticketingFeatureEnabled;
};
exports.getDeviceSchema = (state) => {
    return deviceSchemaSelector.getDeviceSchema(state.deviceSchema, exports.getShouldShowTicketingFeatures(state));
};
exports.getIsAttributeArrayType = (state, keyPath) => deviceSchemaSelector.getIsAttributeArrayType(state.deviceSchema, keyPath);
exports.getSelectedPredicate = (state, index) => eventSchemasSelector.getSelectedPredicate(state, index);
exports.getComparisonOperatorDisplayValue = (comparisonOperator) => eventSchemasSelector.getComparisonOperatorDisplayValue(comparisonOperator);
exports.getSelectedSchemas = (state) => eventSchemasSelector.getSelectedSchemas(state);
exports.getEventSchemas = (state) => eventSchemasSelector.getEventSchemas(state.eventSchemas);
exports.getIsError = (state) => appSelector.getIsError(state.app);
exports.getIsCreatingCampaign = (state) => appSelector.getIsCreatingCampaign(state.app);
exports.getIsFetching = (state) => appSelector.getIsFetching(state.app);
exports.getIsNewCampaignPopoverOpen = (state) => appSelector.getIsNewCampaignPopoverOpen(state.app);
exports.getIsNewCampaignPopoverClosing = (state) => appSelector.getIsNewCampaignPopoverClosing(state.app);
exports.getIsCampaignTypeSelectorOpen = (state) => appSelector.getIsCampaignTypeSelectorOpen(state.app);
exports.getIsCampaignTypeSelectorClosing = (state) => appSelector.getIsCampaignTypeSelectorClosing(state.app);
exports.getAudience = (state) => appSelector.getAudience(state.app);
exports.getTotalAudienceSize = (state) => appSelector.getTotalAudienceSize(state.app);
exports.getIsOverviewModalOpen = (state) => appSelector.getIsOverviewModalOpen(state.app);
exports.getIsArchiveModalOpen = (state) => appSelector.getIsArchiveModalOpen(state.app);
exports.getSelectedTestDevices = (state) => testDevicesSelector.getSelectedTestDevices(state.testDevices);
exports.getIsSendTestModalOpen = (state) => appSelector.getIsSendTestModalOpen(state.app);
exports.getTriggeredAnimation = (state) => appSelector.getTriggeredAnimation(state.app);
exports.getIsPhonePreviewActive = (state, preview) => appSelector.getIsPhonePreviewActive(state.app, preview);
exports.getIsPhonePreviewClosing = (state) => appSelector.getIsPhonePreviewClosing(state.app);
exports.getReportGraphType = (state) => appSelector.getReportGraphType(state.app);
exports.getCurrentFormPage = (state) => appSelector.getCurrentFormPage(state.app);
exports.getSegmentSize = (state) => appSelector.getSegmentSize(state.app);
exports.getShouldShowPhonePreview = (state) => {
    return appSelector.getShouldShowPhonePreview(state);
};
exports.getIsAudienceSizeUpdating = (state) => appSelector.getIsAudienceSizeUpdating(state.app);
exports.getIsDeviceListUploading = (state) => appSelector.getIsDeviceListUploading(state.app);
exports.getIsSegmentSizeUpdating = (state) => appSelector.getIsSegmentSizeUpdating(state.app);
exports.getIsNotificationDeliveryModalOpen = (state) => appSelector.getIsNotificationDeliveryModalOpen(state.app);
exports.getAlertOptionHoverValue = (state) => appSelector.getAlertOptionHoverValue(state.app);
exports.getIsAlertOptionsOpen = (state) => appSelector.getIsAlertOptionsOpen(state.app);
exports.getLastViewPage = (state) => appSelector.getLastViewPage(state.app);
exports.getIsTapBehaviorSelectorOpen = (state) => appSelector.getIsTapBehaviorSelectorOpen(state.app);
exports.getIsTapBehaviorDeepLink = (state) => appSelector.getIsTapBehaviorDeepLink(state.app);
exports.getCurrentWizard = (state) => appSelector.getCurrentWizard(state.app);
exports.getIsWizardModalOpen = (state) => appSelector.getIsWizardModalOpen(state.app);
exports.getIsWizardModalClosing = (state) => appSelector.getIsWizardModalClosing(state.app);
exports.getCampaign = (state, id) => campaignsSelector.getCampaign(state.campaignConnection, id);
exports.getAllCampaigns = (state) => campaignsSelector.getAllCampaigns(state.campaignConnection);
exports.getFilteredCampaigns = (state, filter) => campaignsSelector.getFilteredCampaigns(state.campaignConnection, filter);
exports.getOrderedCampaignList = (state, filter, type) => campaignsSelector.getOrderedCampaignList(state.campaignConnection, filter, type);
exports.getCampaignDisplayTime = (state) => campaignsSelector.getDisplayTime(state);
exports.getScheduledSentAtTime = (state) => campaignsSelector.getScheduledSentAtTime(state);
exports.getCampaignExists = (state, id) => campaignsSelector.getCampaignExists(state.campaignConnection, id);
exports.getCampaignFormatDate = (state, automatedEndDate) => campaignsSelector.getFormatDate(state, automatedEndDate);
exports.getIsCampaignFinished = (state, campaignId) => campaignsSelector.getIsCampaignFinished(state.campaignConnection, campaignId);
exports.getDuplicateCampaignName = (campaign) => campaignsSelector.getDuplicateCampaignName(campaign);
exports.getExperiencePreviewURL = (state, id) => campaignsSelector.getExperiencePreviewURL(state, id);
exports.getEventTriggerFilterByType = (filters, type) => campaignsSelector.getEventTriggerFilterByType(filters, type);
exports.getAPICampaignTrigger = (state, id) => campaignsSelector.getAPICampaignTrigger(state.campaignConnection, id);
exports.getAutomatedCampaignTrigger = (state, id) => campaignsSelector.getAutomatedCampaignTrigger(state.campaignConnection, id);
exports.getScheduledCampaignTrigger = (state, id) => campaignsSelector.getScheduledCampaignTrigger(state.campaignConnection, id);
exports.getPublishedCampaignLifecycleStatus = (state, id) => campaignsSelector.getPublishedCampaignLifecycleStatus(state.campaignConnection, id);
exports.getTags = (state, keyword) => tagsSelector.getTags(state.tags, keyword);
exports.getCampaignTapBehavior = (state, id) => campaignsSelector.getCampaignTapBehavior(state.campaignConnection, id);
exports.getCampaignTimeZone = (state, id) => campaignsSelector.getCampaignTimeZone(state.campaignConnection, id);
exports.getCampaignTriggerSegment = (state, id) => {
    const campaign = exports.getCampaign(state, id);
    const { trigger } = campaign;
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger) || getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        return exports.getSegmentFromTrigger(trigger);
    }
};
exports.getCampaignHasNextPage = (state) => campaignsSelector.getCampaignHasNextPage(state.campaignConnection);
exports.getCampaignHasPreviousPage = (state) => campaignsSelector.getCampaignHasPreviousPage(state.campaignConnection);
exports.getCampaignStartCursor = (state) => campaignsSelector.getCampaignStartCursor(state.campaignConnection);
exports.getCampaignEndCursor = (state) => campaignsSelector.getCampaignEndCursor(state.campaignConnection);
exports.getCampaignReport = (state) => campaignReportSelector.getCampaignReport(state);
exports.getEditableUIState = (state) => editableUIStateSelector.getEditableUIState(state);
exports.getActivePopover = (state) => appSelector.getActivePopover(state.app);
exports.getIsPopoverModalFormOpen = (state) => appSelector.getIsPopoverModalFormOpen(state.app);
exports.getEditableCampaign = (state) => editableCampaignSelector.getEditableCampaign(state);
exports.getShouldShowSaveAndClose = (state) => editableCampaignSelector.getShouldShowSaveAndClose(state);
exports.getEditableCampaignDisplayTime = (state) => editableCampaignSelector.getDisplayTime(state);
exports.getEditableCampaignDayOfWeekDisplayName = (state) => editableCampaignSelector.getEditableCampaignDayOfWeekDisplayName(state);
exports.getEditableCampaignFormatDate = (state) => editableCampaignSelector.getFormatDate(state);
exports.getEditableCampaignFrequencyLimits = (state) => editableCampaignSelector.getEditableCampaignFrequencyLimits(state);
exports.getAutomatedLimitType = (state) => editableCampaignSelector.getAutomatedLimitType(state);
exports.getEditableCampaignTrigger = (state) => editableCampaignSelector.getEditableCampaignTrigger(state);
exports.getEditableEventAttributesEventTriggerFilter = (state) => editableCampaignSelector.getEditableEventAttributesEventTriggerFilter(state);
exports.getEditableCampaignScheduledEventTriggerFilter = (state) => editableCampaignSelector.getEditableCampaignScheduledEventTriggerFilter(state);
exports.getEditableCampaignTimeOfDayEventTriggerFilter = (state) => editableCampaignSelector.getEditableCampaignTimeOfDayEventTriggerFilter(state);
exports.getEditableCampaignDayOfTheWeekEventTriggerFilter = (state) => editableCampaignSelector.getEditableCampaignDayOfTheWeekEventTriggerFilter(state);
exports.getEditableCampaignDeliverable = (state) => editableCampaignSelector.getEditableCampaignDeliverable(state);
exports.getEditableCampaignDeliverableTapBehavior = (state) => editableCampaignSelector.getEditableCampaignDeliverableTapBehavior(state);
exports.getEditableCampaignAutomatedCampaignTrigger = (state) => editableCampaignSelector.getEditableCampaignAutomatedCampaignTrigger(state);
exports.getEditableCampaignEventTrigger = (state) => editableCampaignSelector.getEditableCampaignEventTrigger(state);
exports.getEditableCampaignEventTriggerFilters = (state) => editableCampaignSelector.getEditableCampaignEventTriggerFilters(state);
exports.getEditableCampaignScheduledCampaignTrigger = (state) => editableCampaignSelector.getEditableCampaignScheduledCampaignTrigger(state);
exports.getEditableCampaignSegment = (state) => {
    const { trigger } = exports.getEditableCampaign(state);
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger) || getCampaignType_1.isAutomatedCampaignTrigger(trigger) || getCampaignType_1.isAPICampaignTrigger(trigger)) {
        return exports.getSegmentFromTrigger(trigger);
    }
};
exports.getAllSegments = (state) => segmentsSelector.getAllSegments(state.segments);
exports.getUnselectedSegments = (state) => segmentsSelector.getUnselectedSegments(state);
exports.getSegment = (state, segmentId) => segmentsSelector.getSegment(state.segments, segmentId);
exports.getSegmentFromTrigger = (trigger) => {
    return trigger.segment;
};
exports.getTestDevices = (state) => testDevicesSelector.getTestDevices(state.testDevices);
exports.getExperiences = (state) => experiencesSelector.getExperiences(state.experiences);
exports.getExperience = (state, id) => experiencesSelector.getExperience(state.experiences, id);
exports.getAverageSession = (state) => experienceReportSelector.getAverageSession(state.experienceReport);
exports.getBlockClicks = (state) => experienceReportSelector.getBlockClicks(state.experienceReport);
exports.getScreenViews = (state) => experienceReportSelector.getScreenViews(state.experienceReport);
exports.getUser = (state) => userSelector.getUser(state.user);
exports.getSettings = (state) => userSelector.getSettings(state.user);
exports.getCampaignTotalProgress = (state, id) => {
    const campaign = exports.getCampaign(state, id);
    if (campaign.UIState.length === 0) {
        return 0;
    }
    const uiState = JSON.parse(campaign.UIState);
    delete uiState.apiTrigger;
    const denominator = Object.keys(uiState).length;
    const numerator = Object.keys(uiState)
        .filter((field) => uiState[field].seen)
        .filter((field) => exports.getIsStageValid(campaign, uiState, field)).length;
    return Math.round((numerator / denominator) * 100);
};
exports.getTypeProgress = (campaign, uiState, type) => {
    const fields = Object.keys(uiState).filter((field) => uiState[field].type === type);
    return ((fields
        .filter((field) => uiState[field].seen)
        .filter((field) => exports.getIsStageValid(campaign, uiState, field)).length *
        100) /
        fields.length);
};
exports.getIsComparisonPredicate = (predicate) => predicate.keyPath !== undefined;
exports.getIsCompoundPredicate = (predicate) => predicate.predicates !== undefined;
exports.getIsStageValid = (campaign, uiState, stage) => {
    const { deliverable, trigger } = campaign;
    switch (stage) {
        case 'messageAndMedia':
            if (!deliverable) {
                return false;
            }
            if (getCampaignType_1.isNotificationCampaignDeliverable(deliverable)) {
                return deliverable.body !== '';
            }
            break;
        case 'alertOptions':
            if (getCampaignType_1.isNotificationCampaignDeliverable(deliverable)) {
                const { alertOptions: { notificationCenter, systemNotification }, } = deliverable;
                return (notificationCenter || (systemNotification && exports.getIsStageValid(campaign, uiState, 'messageAndMedia')));
            }
            break;
        case 'tapBehavior':
            if (getCampaignType_1.isNotificationCampaignDeliverable(deliverable)) {
                const { tapBehavior: { type, url, experienceID }, } = deliverable;
                if (!exports.getIsStageValid(campaign, uiState, 'alertOptions')) {
                    return false;
                }
                switch (type) {
                    case 'PRESENT_EXPERIENCE':
                        return experienceID && experienceID !== '';
                    case 'OPEN_URL':
                        try {
                            const testURL = new URL(url);
                            return true;
                        }
                        catch (e) {
                            return false;
                        }
                    case 'PRESENT_WEBSITE':
                        try {
                            const testURL = new URL(url);
                            return testURL.protocol.includes('http');
                        }
                        catch (err) {
                            return false;
                        }
                    case 'DEFAULT':
                    default:
                        return true;
                }
            }
            break;
        case 'advancedSettings':
            return exports.getIsStageValid(campaign, uiState, 'tapBehavior');
        case 'dateAndTime':
            if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
                const { dateTime } = trigger;
                return dateTime ? dateTime.date !== null && dateTime.time !== null : true;
            }
            break;
        case 'audience':
            const isAudienceValid = (segment) => {
                if (!segment) {
                    return true;
                }
                switch (segment.__typename) {
                    case 'CompoundSegment':
                        return segment.ids.length > 0;
                    case 'DeviceListSegment':
                        return !!segment.deviceList.id;
                    case 'DevicePredicateSegment':
                        if (getCampaignType_1.isComparisonPredicate(segment.predicate)) {
                            return true;
                        }
                        if (getCampaignType_1.isCompoundPredicate(segment.predicate)) {
                            return segment.predicate.predicates.length > 0;
                        }
                        return false;
                    default:
                        return true;
                }
            };
            if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
                if (!isAudienceValid(trigger.segment)) {
                    return false;
                }
                return exports.getIsStageValid(campaign, uiState, 'campaignDuration');
            }
            if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
                if (!isAudienceValid(trigger.segment)) {
                    return false;
                }
                return exports.getIsStageValid(campaign, uiState, 'dateAndTime');
            }
            if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
                if (!isAudienceValid(trigger.segment)) {
                    return false;
                }
                return true;
            }
            break;
        case 'eventTrigger':
            if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
                const { eventTrigger: { eventName, filters }, } = trigger;
                if (!eventName) {
                    return false;
                }
                const s = filters.find((f) => f.__typename === 'EventAttributesEventTriggerFilter');
                if (s && getCampaignType_1.isEventAttributesEventTriggerFilter(s)) {
                    const { predicate } = s;
                    if (exports.getIsCompoundPredicate(predicate)) {
                        if (predicate.booleanOperator === 'NOT') {
                            return true;
                        }
                        if (predicate.predicates.length === 0) {
                            return false;
                        }
                    }
                }
                return true;
            }
            break;
        case 'campaignDuration':
            if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
                const s = trigger.eventTrigger.filters.find((f) => f.__typename === 'ScheduledEventTriggerFilter');
                if (!s) {
                    return false;
                }
                if (s && getCampaignType_1.isScheduledEventTriggerFilter(s)) {
                    if (!s.startDateTime) {
                        return false;
                    }
                }
            }
            return exports.getIsStageValid(campaign, uiState, 'eventTrigger');
        case 'frequencyLimits':
            return exports.getIsStageValid(campaign, uiState, 'audience');
        case 'apiTrigger':
            return true;
        default:
            return false;
    }
};
exports.getAutomatedActiveStatus = (state, id) => campaignsSelector.getAutomatedActiveStatus(state.campaignConnection, id);
exports.getFormattedReport = (state) => reportsSelector.getFormattedReport(state.reports, exports.getReportGraphType(state));
exports.getReportHasNextPage = (state) => reportsSelector.getReportHasNextPage(state.reports);
exports.getReportHasPreviousPage = (state) => reportsSelector.getReportHasPreviousPage(state.reports);
exports.getReportStartCursor = (state) => reportsSelector.getReportStartCursor(state.reports);
exports.getReportEndCursor = (state) => reportsSelector.getReportEndCursor(state.reports);
